import React from 'react';
import { withStyles } from '@material-ui/styles';

const styles = (theme) => ({
  categoryParent: {
    height: '100%',
    width: 'fit-content',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    backgroundColor: '#fff',
    color: '#1E1E1E',
    borderRadius: '30px',
    marginRight: '15px',
  },
  categoryText: {
    fontWeight: '400',
    fontSize: '14px',
    letterSpacing: '0.5px',
  },
});

function formatCategoryName(name) {
  return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
}

function getBackgroundStyle(selected) {
  return selected ? { backgroundColor: '#E50218', color: '#fff', paddingRight: '20px', paddingLeft: '20px' } : {};
}
function getTextStyle(selected) {
  return selected ? { fontWeight: '600' } : {};
}

function CategoryView(props) {
  const { classes, category, categorySelected } = props;
  return (
    <div
      style={getBackgroundStyle(category.selected)}
      className={classes.categoryParent}
      onClick={() => {
        categorySelected(category);
      }}
    >
      <span style={getTextStyle(category.selected)} className={classes.categoryText}>
        {formatCategoryName(category.name)}
      </span>
    </div>
  );
}

export default withStyles(styles)(CategoryView);
